/* 상태색 — 토폴로지 뷰 디자인(상태 범례) 기준. SVG 속성·미니맵은 CSS var() 를 못 써서 hex 를 따로 둔다.
 * styles/dfv.css 의 --status-* 와 같은 값을 유지할 것. */
export const STATUS_HEX = {
    running: "#4E8DF5",    // 수집 중
    healthy: "#47CD89",    // 정상
    warning: "#FDB022",    // 경고
    error: "#F04438",      // 오류
    recovering: "#9E77ED", // 복구 중
    offline: "#98A8BF",    // 정지
};
/** 범례·상태 칩 순서 (디자인: 수집 중 → 정상 → 경고 → 오류 → 복구 중 → 정지) */
export const STATUS_ORDER = ["running", "healthy", "warning", "error", "recovering", "offline"];
/** 상태별 한 줄 설명 (범례 툴팁) */
export const STATUS_HINT_KO = {
    running: "최근 10분 내 샷 도착 · 데이터 흐름 중",
    healthy: "정상 · 흐름은 있으나 최근 1분 도착 없음",
    warning: "경고 · 10~30분 샷 없음 / 동기화 지연",
    error: "오류 · 동기화 실패 등",
    recovering: "복구 중 · 재연결 후 안정화 대기",
    offline: "정지 · 30분 이상 샷 없음 또는 미연동",
};
/** 엣지를 점선으로 그리는 상태 (범례: 경고·오류 점선) */
export const DASHED_STATUSES = new Set(["warning", "error"]);
/** 선택 노드와 무관한 노드·엣지 투명도 */
export const DIM_OPACITY_UNRELATED = 0.25;
/** 필터 불일치 노드 투명도 */
export const DIM_OPACITY_FILTERED = 0.3;
